export default function diameterOrDiagonal(dimensions, widthPower = 2, lengthPower = 2, divisor = 1) {
  return Object.hasOwn(dimensions, 'diameter') ? dimensions.diameter : diagonal(dimensions, widthPower, lengthPower) / divisor;
}

export function diagonal(dimensions, widthPower, lengthPower) {
  return Math.sqrt(Math.pow(dimensions?.width, widthPower) + Math.pow(dimensions?.length, lengthPower));
}
